import React, { useState, createContext } from "react";
import { SnackbarProvider } from "notistack";

export const ContextGlobal = createContext();

const ContextProvider = ({ children }) => {
  const [data, setData] = useState([]);

  return (
    <ContextGlobal.Provider value={{ data, setData }}>
      <SnackbarProvider maxSnack={4}>{children}</SnackbarProvider>
    </ContextGlobal.Provider>
  );
};

export default ContextProvider;
